import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import Axios from 'axios';

const baseUrl = url;
export const WEB_LAYOUT_FETCH = createAction('WEB_LAYOUT_FETCH');
export const WEB_LAYOUT_FETCH_DATA_SUCCESS = createAction(
  'WEB_LAYOUT_FETCH_DATA_SUCCESS'
);
export const WEB_LAYOUT_FETCH_DATA_FAIL = createAction(
  'WEB_LAYOUT_FETCH_DATA_FAIL'
);

export const WEB_LAYOUT_DELETE_INIT = createAction('WEB_LAYOUT_DELETE_INIT');
export const WEB_LAYOUT_DELETE_SUCCESS = createAction(
  'WEB_LAYOUT_DELETE_SUCCESS'
);
export const WEB_LAYOUT_DELETE_FAIL = createAction('WEB_LAYOUT_DELETE_FAIL');

export const WEB_LAYOUT_CLEAR_DATA = createAction('WEB_LAYOUT_CLEAR_DATA');

export const WEB_LAYOUT_CREATE_INIT = createAction('WEB_LAYOUT_CREATE_INIT');
export const WEB_LAYOUT_CREATE_SUCCESS = createAction(
  'WEB_LAYOUT_CREATE_SUCCESS'
);
export const WEB_LAYOUT_CREATE_FAIL = createAction('WEB_LAYOUT_CREATE_FAIL');

export const WEB_LAYOUT_MODIFY_INIT = createAction('WEB_LAYOUT_MODIFY_INIT');
export const WEB_LAYOUT_MODIFY_SUCCESS = createAction(
  'WEB_LAYOUT_MODIFY_SUCCESS'
);
export const WEB_LAYOUT_MODIFY_FAIL = createAction('WEB_LAYOUT_MODIFY_FAIL');

export const WEB_LAYOUT_CLEAN_UP = createAction('WEB_LAYOUT_CLEAN_UP');

export const WEB_LAYOUT_CLEAR_DATA_LOGOUT = createAction(
  'WEB_LAYOUT_CLEAR_DATA_LOGOUT'
);
export const WEB_LAYOUT_BULK = createAction('WEB_LAYOUT_BULK');

export const fetchWebLayout = ({ siteId }) => {
  return async (dispatch, getState) => {
    dispatch(WEB_LAYOUT_FETCH());
    let webLayoutData;
    try {
      webLayoutData = await Axios.get(`${baseUrl}/webLayout/list/${siteId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_LAYOUT_FETCH_DATA_FAIL({ error }));
    }
    const WEB_LAYOUT = { ...webLayoutData.data };
    return dispatch(
      WEB_LAYOUT_FETCH_DATA_SUCCESS({
        list: getState().webPages.list,
        WEB_LAYOUT,
      })
    );
  };
};

export const addWebLayout = (payload, cb) => {
  return async (dispatch, getState) => {
    let webLayoutData;
    try {
      webLayoutData = await Axios.post(`${baseUrl}/webLayout/create`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_LAYOUT_CREATE_FAIL({ error }));
    }
    cb && cb();
    toastr.success('', 'The layout was created.');
    return dispatch(
      WEB_LAYOUT_CREATE_SUCCESS({ layout: [webLayoutData.data.data] })
    );
  };
};

export const updateWebLayout = (id, payload, cb) => {
  return async (dispatch, getState) => {
    let webLayoutData;
    try {
      webLayoutData = await Axios.put(`${baseUrl}/webLayout/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      console.log('error update web layout', error);
      toastr.error('', errorMessage);
      return dispatch(WEB_LAYOUT_MODIFY_FAIL({ error }));
    }
    cb && cb();
    toastr.success('', 'The layout was updated.');
    return dispatch(
      WEB_LAYOUT_MODIFY_SUCCESS({ layout: webLayoutData.data.data, id })
    );
  };
};

export const deleteWebLayout = (id, cb) => {
  return async (dispatch, getState) => {
    try {
      await Axios.delete(`${baseUrl}/webLayout/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      cb && cb();
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('Failed', errorMessage);
      return dispatch(WEB_LAYOUT_DELETE_FAIL({ error }));
    }
    toastr.success('', 'The layout was removed.');
    return dispatch(WEB_LAYOUT_DELETE_SUCCESS({ id }));
  };
};
